import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state: {
    newCompanies: [],
    aboutUs: {},
    fundingOpportunities: {},
    newCompaniesIdMap: {},
    contactPeople: [],
    communeNames: [],
  },
  mutations,
  actions,
  getters,
};
